// GloboContactoLanding.jsx
import React from "react";
import "./GloboContactoLanding.Module.css";
import botonContacto from "../../assets/svg-redes/BOTON_CONTACTO.png";

function GloboContactoLanding({ posicion }) {
  const [respira, setRespira] = React.useState(false);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setRespira((prev) => !prev);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const whatsappLink =
    "https://api.whatsapp.com/message/RUJEODHSOVNFK1?autoload=1&app_absent=0";

  return (
    <div className="derechaButtonHome">
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="botonGloboLandingLink"
        aria-label="Chatear por WhatsApp"
      >
        <div className={`imgBotonGlobo ${respira ? "respira" : ""}`}>
          {/* TEXTO CURVO */}
          <svg className="curvedText" viewBox="0 0 100 100" aria-hidden="true">
            <defs>
              {/* ARCO SUPERIOR */}
              <path id="topArcLanding" d="M 15 50 A 35 35 0 0 1 85 50" />
              {/* ARCO INFERIOR (bajado para que CON NOSOTRAS quede más abajo) */}
              <path id="bottomArcLanding" d="M 15 58 A 35 35 0 0 0 85 58" />
            </defs>

            {/* TEXTO ARRIBA */}
            <text className="curvedTextTop">
              <textPath href="#topArcLanding" startOffset="50%" textAnchor="middle">
                CHATEÁ
              </textPath>
            </text>

            {/* TEXTO ABAJO */}
            <text className="curvedTextBottom">
              <textPath href="#bottomArcLanding" startOffset="50%" textAnchor="middle">
                CON NOSOTRAS
              </textPath>
            </text>
          </svg>

          <img src={botonContacto} alt="Botón WhatsApp" />
        </div>
      </a>
    </div>
  );
}

export default GloboContactoLanding;
